export default __webpack_public_path__ + "static/media/apple.8500607c.svg";